import { render, staticRenderFns } from "./modalNotSaved.vue?vue&type=template&id=82f4f95e&scoped=true&"
import script from "./modalNotSaved.vue?vue&type=script&lang=js&"
export * from "./modalNotSaved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f4f95e",
  null
  
)

export default component.exports